/***
*
*   ACCOUNT
*   Index page for account functions
*
**********/
import React, { useContext } from 'react';
import { AuthContext, Animate, Grid, Card, Icon, Link, useAPI, Loader, usePlans, useCan } from 'components/lib';
import ProfileSetup from './setup';
import Styles from './account.module.scss';

export function Account(props) {
	const context = useContext(AuthContext);
	const user = useAPI('/api/user');
	const permission = useCan('account.view')
	const permissionBilling = useCan('account.billing.view')
	const permissionDeveloper = useCan('account.developer.view')
	const permissionAdmin = useCan('account.admin.view')
	const iconSize = 20;
	// Get the all plans
	const allPlans = usePlans();
	const plan = allPlans?.data?.raw?.plans.find((x) => x.id === context?.user?.plan);

	if (user.loading)
		return <Loader />

	return (
		<>
			<Animate>
				{user?.data?.onboarded ? (
					<Grid cols='4'>
						<Card className={Styles.cardContainer}>
							<Icon image='user' size={iconSize} />
							<h2>{props.t('account.profile.title')}</h2>
							<div>{props.t('account.profile.description')}</div>
							<Link url='/account/profile' className={Style.link}>
								{props.t('account.profile.button')}
							</Link>
						</Card>

						<Card className={Styles.cardContainer}>
							<Icon image='lock' size={iconSize} />
							<h2>{props.t('account.password.title')}</h2>
							<div>{user?.data?.['has_password'] ? props.t('account.password.description.change') : props.t('account.password.description.create')}</div>
							<Link url='/account/password'>
								{user?.data?.['has_password'] ? props.t('account.password.button.change') : props.t('account.password.button.create')}
							</Link>
						</Card>

						<Card className={Styles.cardContainer}>
							<Icon image='shield' size={iconSize} />
							<h2 className={Style.subtitle}>{props.t('account.2fa.title')}</h2>
							<div>{props.t('account.2fa.description')}</div>
							<Link url='/account/2fa' className={Style.link}>
								{user?.data?.['2fa_enabled'] ? props.t('account.2fa.button.manage') : props.t('account.2fa.button.enable')}
							</Link>
						</Card>

						{(permission && permissionBilling && plan?.payment_method !== 'external') && ( 
							<Card className={Styles.cardContainer}>
								<Icon image='credit-card' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.billing.title')}</h2>
								<div>{props.t('account.billing.description')}</div>
								<Link url='/account/billing' className={Style.link}>
									{props.t('account.billing.button')}
								</Link>
							</Card>
						)}

						{permission && permissionDeveloper && ( 
							<Card className={Styles.cardContainer}>
								<Icon image='settings' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.api_keys.title')}</h2>
								<div>{props.t('account.api_keys.description')}</div>
								<Link url='/account/apikeys' className={Style.link}>
									{props.t('account.api_keys.button')}
								</Link>
							</Card>
						)}

						{permission && permissionAdmin && ( 
							<Card className={Styles.cardContainer}>
								<Icon image='users' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.users.title')}</h2>
								<div>{props.t('account.users.description')}</div>
								<Link url='/account/users' className={Style.link}>
									{props.t('account.users.button')}
								</Link>
							</Card>
						)}

						{permission && permissionAdmin && context?.user?.lms_enabled && ( 
							<Card className={Styles.cardContainer}>
								<Icon image='users' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.hierarchy.title')}</h2>
								<div>{props.t('account.hierarchy.description')}</div>
								<Link url='/account/hierarchy' className={Style.link}>
									{props.t('account.hierarchy.button')}
								</Link>
							</Card>
						)}
						{/* //TODO Need to Remove this block lms condition on LMS plans phase out*/}
						{plan?.enterprise && permission && permissionAdmin && !context.user.lms_only && ( 
							<Card className={Styles.cardContainer}>
								<Icon image='file' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.LearningPath.title')}</h2>
								<div>{props.t('account.LearningPath.description')}</div>
								<Link url='/account/lpath' className={Style.link}>
									{props.t('account.LearningPath.button')} </Link>
							</Card>
						)}
						{!plan?.enterprise && plan?.payment_method !== 'external' && (
							<Card className={Styles.cardContainer}>
								<Icon image='chevrons-up' size={iconSize} />
								<h2 className={Style.subtitle}>{props.t('account.upgrade.title')}</h2>
								<div>{props.t('account.upgrade.subtitle')}</div>
								<Link url='/account/upgrade' className={Style.link}>
									{props.t('account.upgrade.button')} </Link>
							</Card>
						)}

					</Grid>
				) : (
					<ProfileSetup userDetails={user?.data} t={props.t} />
				)}
			</Animate>
		</>
	)
}

const Style = {

	subtitle: 'font-bold mt-4',
	link: 'text-blue-500 font-semibold mt-3 inline-block'

}